import { render, staticRenderFns } from "./navbar-footer.vue?vue&type=template&id=e80a6596&scoped=true&"
import script from "./navbar-footer.vue?vue&type=script&lang=js&"
export * from "./navbar-footer.vue?vue&type=script&lang=js&"
import style0 from "./navbar-footer.vue?vue&type=style&index=0&id=e80a6596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a6596",
  null
  
)

export default component.exports